<!--
Author: TangChen
Date: 2018-09-22
Desc: 银行卡列表内容
-->
<template>
    <div class="comp-bank-lists comp">
        <el-dialog :title="title" :visible.sync="visible" class="prop" width="880px" v-on:close="dialogClose">
            <div v-if="!isConfirm" class="bank-sel">
                <el-row v-if="bankLists.length>0" :gutter="12" class="bank-msg">
                    <el-col v-for="(bank,index) in bankLists" :key="index" :span="(icon==='up'||index < 24) ? 6 : 0">
                        <div v-if="icon==='up'||index<24" class="bank-list" v-on:click="selBank(bank.bankid)">
                            <div class="bank-img">
                                <img :src="$util.getImg(bank.bankid)">
                                <span
                                    class="k-text-flow"
                                    :class="{'fonts':bank.channelname.length>=6}"
                                    :title="bank.channelname"
                                >{{ bank.channelname.toString().substr(0,6) }}</span>
                            </div>
                            <!--<p class="k-text-flow" :title="bank.bankinfo">{{bank.bankinfo}}</p>-->
                        </div>
                    </el-col>
                    <el-col v-if="bankLists.length>24" :span="24" class="more">
                        <div v-on:click.prevent="icon=icon==='down'?'up':'down'">
                            <i :class="'fa fa-chevron-'+icon" />{{icon==='down'?'更多银行':'收起'}}
                        </div>
                    </el-col>
                </el-row>
                <div v-if="bankLists.length===0" class="no-banks">
                    暂无可用网点
                </div>
            </div>
            <div v-if="isConfirm" class="bank-confirm">
                <el-row v-if="channels.length>0" :gutter="12" class="bank-msg">
                    <el-col v-for="(bank,index) in channels" :key="index" :span="6">
                        <div
                            v-if="index<3"
                            class="bank-list"
                            :class="{'is-active':selBankId===bank.channelid}"
                            v-on:click="confirmBank(bank.channelid)"
                        >
                            <div class="bank-img">
                                <img :src="$util.getImg(bank.bankid)">
                                <span
                                    class="k-text-flow"
                                    :class="{'fonts':bank.channelname.length>=6}"
                                    :title="bank.channelname"
                                >{{ bank.channelname.toString().substr(0,6) }}</span>
                                <i class="paycenter" :title="bank.paycentername">{{ bank.paycentername.toString().substr(0,4) }}</i>
                            </div>
                            <!--<p class="k-text-flow">{{bank.bankinfo}}</p>-->
                            <i class="fa fa-check" />
                        </div>
                    </el-col>
                    <el-col v-if="confirm[0]" :span="24" class="sel-bank-msg">
                        您已选择<span class="red">{{ confirm[0].channelname +'('+
                            confirm[0].paycentername +')' }}渠道</span>
                        <!--显示鉴权方式-->
                        ，{{ confirm[0].paycenterid == "2000" ? '为了您的账户安全，该渠道需通过上传银行卡照片进行验证，审核通过后该银行卡方可进行交易。' : '该渠道是通过'+identifyWay[confirm[0].identifytype]+'。' }}
                        <span v-cloak v-if="confirm[0]&&confirm[0].remark.trim()!==''">绑卡额度：{{ confirm[0].remark }}</span>
                    </el-col>
                    <el-col v-if="confirm[0]&&confirm[0].discount.trim()!==''" :span="24" class="sel-bank-msg">
                        折扣信息：<span class="red">{{ confirm[0].discount }}</span>
                    </el-col>
                    <el-col v-if="confirm[0] && confirm[0].hint" :span="24" class="hint-con">
                        <hint :hints="confirm[0].hint" />
                    </el-col>
                </el-row>
            </div>
            <div v-if="isConfirm" slot="footer" class="other dialog-footer">
                <div class="btn-box">
                    <el-button v-if="bankLists.length!==1" v-on:click="isConfirm=false">
                        返回上一步
                    </el-button>
                    <el-button type="primary" :disabled="selBankId===-1" v-on:click="back()">
                        确 定
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import hint from "@/components/misc/hint.vue";
export default {
    name: "BankLists",
    components: {
        hint
    },
    props: {
        bankVisible: {
            type: Boolean,
            required: true
        },
        url: {
            type: String,
            default: "acct/resettradepwd/banklist"
        }
    },
    data () {
        return {
            visible: false, // 是否显示dialog
            bankLists: [],
            identifyWay: ["", "手机号码进行短信验证", "后台数据校验", "页面银行卡验证"],
            icon: "down",
            isConfirm: false,
            channels: [],
            confirm: [],
            title: "请选择银行",
            selBankId: -1 // 选中索引值
        };
    },
    watch: {
        bankVisible (val) {
            this.visible = val;
        },
        isConfirm (val) {
            this.title = val ? "请选择渠道" : "请选择银行";
            this.confirm = [];
        }
    },
    created () {
        this.initBank();
    },
    methods: {
        /* 初始化银行卡信息 */
        initBank () {
            const _this = this;
            this.$util.getBankInfo(this.url,{biztype2: this.$route.query ? this.$route.query.biztype : ""}, res => {
                _this.bankLists = res || [];
                if(_this.bankLists.length === 1){
                    _this.selBank(_this.bankLists[0].bankid);
                    _this.isConfirm = true;
                }
            });
        },
        /* 关闭银行卡选择界面 */
        dialogClose (val) {
            this.isConfirm = false;
            this.$emit("bank-hide");
        },
        /* 选中银行卡 */
        selBank (val) {
            const selBank = this.bankLists.filter(bank => {
                return bank.bankid === val;
            });
            this.channels = selBank[0].child;
            this.isConfirm = true;
            this.selBankId = -1;
        },
        /* 确认选中银行卡网点 */
        confirmBank (val) {
            this.selBankId = val;
            this.confirm = this.channels.filter(bank => {
                return bank.channelid === val;
            });
        },
        /* 传值给父组件 */
        back () {
            this.isConfirm = false;
            let _x = {};
            if (this.selBankId !== -1) {
                _x.bank = {};
                _x.bank = this.confirm[0];
            }
            this.$emit("bank-hide", _x);
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-bank-lists .prop {
    .el-dialog__header,
    .el-dialog__body .other-bank {
        padding: 13px 24px;
        border-bottom: 2px solid $border-color3;
        font-size: $f16;
        .el-dialog__headerbtn {
            top: 13px;
        }
        .el-dialog__title {
            font-size: $f16;
        }
    }
    .el-dialog {
        border-radius: 4px 4px;
    }
    .el-dialog__body {
        text-align: left;
        padding: 15px 20px;
        .other-bank {
            margin-bottom: 15px;
        }
        .el-col {
            &.sel-bank-msg {
                span {
                    color: $text-color2;
                    &.red {
                        color: $color-c;
                        padding: 0 3px;
                    }
                }
            }
            &.hint-con {
                margin-top: 12px;
            }
            &.more {
                text-align: center;
                color: $color-b;
                div {
                    cursor: pointer;
                    display: inline-block;
                    i {
                        padding: 0 5px;
                    }
                }
            }
            margin-bottom: 14px;
            .bank-list {
                border: 1px solid $border-color2;
                border-radius: 4px 4px;
                box-shadow: 0 0 4px $border-color2;
                cursor: pointer;
                padding: 3px 5px 4px;
                position: relative;
                &:hover,
                &.is-active {
                    border-color: $color-a;
                    box-shadow: 0 0 4px $color-a;
                }
                .fa.fa-check {
                    font-size: $f12;
                    color: $text-color6;
                    position: absolute;
                    right: 1px;
                    bottom: 3px;
                    display: none;
                }
                &.is-active {
                    .fa.fa-check {
                        display: block;
                    }
                    &:before {
                        position: absolute;
                        right: -1px;
                        bottom: -1px;
                        content: "";
                        border: 15px solid $color-a;
                        border-bottom-right-radius: 4px 4px;
                        border-top-color: transparent;
                        border-left-color: transparent;
                    }
                }
                .bank-img {
                    height: 34px;
                    span {
                        color: $text-color2;
                        font-size: $f18;
                        vertical-align: middle;
                        line-height: 30px;
                        margin-left: 4px;
                        &.fonts {
                            font-size: $f16;
                        }
                    }
                    i {
                        margin-top: 5px;
                        float: right;
                        line-height: 20px;
                    }
                }
                & > p {
                    color: $text-color3;
                    line-height: 22px;
                }
            }
        }
    }
    .el-dialog__footer {
        .btn-box {
            text-align: center;
        }
    }
    .bank-sel{
        height: 400px;
        overflow-y: scroll;
        overflow-x: hidden;
    }
}
</style>
